<template>
  <button @click="clickMe" class="c-btn" :class="{ loading: loading }">
    <slot></slot>
  </button>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';

const emit = defineEmits(['click']);
const loading = ref(false);

const setLoading = (newVal) => {
  loading.value = newVal;
};

const clickMe = () => {
  setLoading(true);
  emit('click');
};

defineExpose({ setLoading });
</script>
